export enum VoteDirection {
  Up = 1,
  None = 0,
  Down = -1,
}
